import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardService } from '../../dashboard/dashboard.service';

@Component({
    selector: 'app-payment-notifications',
    templateUrl: './payment-notifications.component.html',
    styleUrls: ['./payment-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentNotificationsComponent implements OnInit {
  loader: boolean = true;
  rows: any = [];
  displayedColumns: string[] = ['title', 'loanId', 'instituteName', 'type'];
  noData: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.getNotifications();
  }
  getNotifications() {
    this.dashboardService.getNotifications().subscribe(
      (res) => {
        if (res.data) {
          // this.loader = false;
          this.rows = res.data;
          this.noData = false;
        }
      },
      (err) => {
        this.noData = true;
      }
    );
  }
}
